/**
 * @desc 其他工具函数
 * @author
 * @date 2021-09-09
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * promise 异常统一获取
 * @param promise
 * @returns
 */
export function to(promise) {
    return __awaiter(this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, promise];
                case 1: return [2 /*return*/, [_a.sent(), null]];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, [null, e_1]];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * 获取服务器时间
 * http请求会返回serverTime字段，通过axios的response拦截器设置全局变量__serverTime__
 */
export function getServerTime() {
    var win = window;
    var currentTime = parseInt((Date.now() / 1000).toString(), 10);
    if (win.__serverTimeDiff__) {
        currentTime += win.__serverTimeDiff__;
    }
    return currentTime;
}
/**
 * 将px转成rem
 * 注意：这个方法依赖库lib-flexible，所以必须保证你引入了这个库
 * @param pxValue px单位像素值
 */
/**
 * 将px转成rem
 * 注意：这个方法依赖库lib-flexible，所以必须保证你引入了这个库
 * @param pxValue px单位像素值
 * @param addUnit 返回值是否带单位（rem）默认不带单位
 * @returns
 */
export function px2rem(pxValue, addUnit) {
    if (addUnit === void 0) { addUnit = false; }
    var win = window;
    // lib-flexible会把当前的rem值保存在window.rem中
    if (!win.rem) {
        throw '调用该方法前必须引入lib-flexible组件库';
    }
    return "".concat(((pxValue * 1) / (win.rem * 2)).toFixed(2)).concat(addUnit ? 'rem' : '');
}
/**
 * 滚动到顶部
 */
export function scrollTop() {
    var docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (docScrollTop !== 0) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
/**
 * 睡眠
 * @param timeout 睡眠时间 ms
 * @returns
 */
export function sleep(timeout) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, timeout);
    });
}
/**
 * 判断是否是对象
 * @param data
 * @returns
 */
export function isObject(data) {
    return Object.prototype.toString.call(data) === '[object Object]';
}
/**
 * param参数转化为Object
 * 比如"a=1&b=2"转换成{a:1,b:2}
 * @param params
 */
export function paramsToObject(params) {
    if (!params)
        return {};
    if (isObject(params))
        return params;
    var obj = {};
    var paramsArr = params.split('&');
    var param;
    paramsArr.forEach(function (item) {
        param = item.split('=');
        obj[param[0]] = param[1] || '';
    });
    return obj;
}
/**
 * 禁止页面滚动
 */
export var limitScroll = function () {
    var mo = function (e) {
        e.preventDefault();
    };
    document.body.style.overflow = 'hidden';
    document.addEventListener('touchmove', mo, false);
};
/**
 * 恢复页面滚动
 */
export var activateScroll = function () {
    var mo = function (e) {
        e.preventDefault();
    };
    document.body.style.overflow = '';
    document.removeEventListener('touchmove', mo, false);
};
/**
 * 掩码
 * @param value 原串
 * @param mask 掩码标识符
 * @param n 明文位数
 * @returns
 */
export var maskCharacter = function (value, mask, n) {
    if (n === void 0) { n = 1; }
    var valueString = '';
    if (typeof value === 'number') {
        valueString = value.toString();
    }
    else {
        valueString = value;
    }
    return valueString.slice(0, -n).replace(/./g, mask) + valueString.slice(-n);
};
export * from './jump';
export * from './utils';
